
import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import {useTranslation} from "react-i18next";
import {CART_NOTIFICATION} from "../../../locales/components/namespaces";

export default function OrderDetailsSection({
                                                additionalInfoText,
                                                deliveryDetailsText,
                                                billingDetailsText,
                                                shippingDetailsText,
                                            }) {
const {t} = useTranslation(CART_NOTIFICATION);
    return (
        <Box sx={{ mt: { xs: 4, md: 6 } }}>

            <Box sx={{ mb: 4 }}>
                <Typography
                    sx={{
                        fontFamily: "'Roboto Condensed', sans-serif",
                        fontWeight: 700,
                        fontSize: 14,
                        lineHeight: "90%",
                        textTransform: "uppercase",
                        color: "#111111",
                        mb: 1.5,
                    }}
                >
                    {t("Additional information")}
                </Typography>

                <Paper
                    sx={{
                        backgroundColor: "#E9E9E9",
                        borderRadius: "10px",
                        px: { xs: 2, md: 3 },
                        py: 2,
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontSize: 16,
                            lineHeight: "120%",
                            color: "#111111",
                        }}
                    >
                        {additionalInfoText}
                    </Typography>
                </Paper>
            </Box>

            {/* 3 columns */}
            <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontWeight: 700,
                            fontSize: 14,
                            lineHeight: "90%",
                            textTransform: "uppercase",
                            color: "#111111",
                            mb: 2,
                        }}
                    >
                        {t("Delivery information")}
                    </Typography>
                    <Typography
                        sx={{
                            whiteSpace: "pre-line",
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontSize: 16,
                            lineHeight: "120%",
                            color: "#000000",
                        }}
                    >
                        {deliveryDetailsText}
                    </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontWeight: 700,
                            fontSize: 14,
                            lineHeight: "90%",
                            textTransform: "uppercase",
                            color: "#111111",
                            mb: 2,
                        }}
                    >
                        {t("Invoice Details")}
                    </Typography>
                    <Typography
                        sx={{
                            whiteSpace: "pre-line",
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontSize: 16,
                            lineHeight: "120%",
                            color: "#000000",
                        }}
                    >
                        {billingDetailsText}
                    </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontWeight: 700,
                            fontSize: 14,
                            lineHeight: "90%",
                            textTransform: "uppercase",
                            color: "#111111",
                            mb: 2,
                        }}
                    >
                        {t("Shipping Carrier")}
                    </Typography>
                    <Typography
                        sx={{
                            whiteSpace: "pre-line",
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontSize: 16,
                            lineHeight: "120%",
                            color: "#000000",
                        }}
                    >
                        {shippingDetailsText}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
}
